import deepmerge from 'deepmerge';

export class EchartsBuilder {
    /**
     * Stores the chart options.
     *
     * @var {Object}
     */
    configuration = {};

    constructor(configuration) {
        this.configuration = configuration;
    }

    options(configuration) {
        this.configuration = deepmerge(this.configuration, configuration);
        return this;
    }

    /**
     * Copies the current builder.
     *
     * @returns {EchartsBuilder}
     */
    copy() {
        return new EchartsBuilder(JSON.parse(JSON.stringify(this.configuration)));
    }
}
